import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('access_token');
    const storedUser = localStorage.getItem('user');
    
    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error('Failed to parse stored user:', e);
        localStorage.removeItem('user');
        localStorage.removeItem('access_token');
      }
    }
    
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await api.post('/auth/login', { email, password }, { withCredentials: true });
      const { access_token, user: userData } = response.data;
      console.log('Login response data:', response.data);
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
      
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Login failed. Please try again.',
      };
    }
  };
// const login = async (email, password) => {
//   try {
//     const response = await api.post('/auth/login', { email, password });

//     const { user: userData } = response.data;

//     console.log('Login response data:', response.data);

//     // Store user only
//     localStorage.setItem('access_token', response.data.access_token);
//     localStorage.setItem('user', JSON.stringify(userData), );

//     setUser(userData);

//     return { success: true };

//   } catch (error) {
//     return {
//       success: false,
//       error: error.response?.data?.detail || 'Login failed. Please try again.',
//     };
//   }
// };

const register = async (userData) => {
  try {
    // Ensure API call returns before trying to login
    await api.post("/auth/register", userData,  { withCredentials: true });

    // Auto-login - do not rely on cookies alone to populate local state
    return await login(userData.email, userData.password);
  } catch (err) {
    const message =
      err?.response?.data?.detail ||
      err?.response?.data?.message ||
      err?.message ||
      "Registration failed";
    return { success: false, error: message };
  }
};

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/login';
  };

  const value = {
    user,
    loading,
    login,
    register,
    logout,
    isAuthenticated: !!user,
    isAdmin: user?.role === 'admin',
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};